import { render, staticRenderFns } from "./UploadLiveStageResources.vue?vue&type=template&id=39203408"
import script from "./UploadLiveStageResources.vue?vue&type=script&lang=js"
export * from "./UploadLiveStageResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports